<template>
    <div class="flex mr-8">
        <vs-button @click="onClickSupportApp" icon-pack="feather" icon="icon-external-link" color="success"
            type="border" v-can="'view-customer-support'">Support App</vs-button>
    </div>
</template>
<script>
import { SUPPORT_APP_URL } from "@/constants/config";
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const StaffRepository = RepositoryFactory.get('staff')
export default {
    name: "SupportApp",
    data() {
        return {
            SUPPORT_APP_URL: SUPPORT_APP_URL
        }
    },
    methods: {
        async onClickSupportApp() {
            try {
                const { data } = (await StaffRepository.fetchSupportAppToken()).data
                window.open(`${SUPPORT_APP_URL}/auth?code=${data.sso_token}&type=Landlord`, '_blank');
            } catch (error) {

            }
        }
    }
}
</script>
<style lang="">

</style>